import { actionCreatorFactory } from 'typescript-fsa';
import { PersistedUser, PersistedUserInvite } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('REGISTRATION');
const fetchInvitationCode = createAction.async<void, PersistedUserInvite, Error>('FETCH');
const acceptInvitationCode = createAction.async<void, PersistedUser, Error>('ACCEPT');

export { fetchInvitationCode, acceptInvitationCode };
